import {
  useIsMapsClient,
  useIsMapsRegionalMimicClient,
  useMapsAgentMimicClient
} from 'store/features/auth';
import { useUserSettings } from 'store/features/user';

export const useShowFavouriteStationsActions = () => {
  const isMapsClient = useIsMapsClient();
  const isMapsRegionalMimicClient = useIsMapsRegionalMimicClient();
  const isMapsAgentMimicClient = useMapsAgentMimicClient();
  const { allowFavouritesControlToMimicClient } = useUserSettings() || {};

  return isMapsClient || ((isMapsRegionalMimicClient || isMapsAgentMimicClient) && allowFavouritesControlToMimicClient);
};
